var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 528,
    height: 548,
    viewBox: "0 0 528 548",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M399.444 408.157C315.085 422.081 114.505 221.704 128.456 137.447C118.223 138.113 109.673 141.222 103.34 147.016C76.4676 171.719 94.5118 228.672 139.561 291.238L100.191 330.566C273.753 485.869 338.954 487.308 425.529 397.632C419.111 404.044 410.21 407.455 399.432 408.157H399.444Z",
    fill: "url(#paint0_linear_222_1233)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.963 137.821C212.321 123.91 412.901 324.263 398.95 408.519C462.903 399.954 437.158 323.27 387.833 254.74L427.203 215.413C285.321 77.2513 204.002 77.8923 147.629 105.401C136.876 111.087 111.081 139.951 101.865 148.334C108.284 141.922 117.185 138.511 127.963 137.809V137.821Z",
    fill: "url(#paint1_linear_222_1233)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_1233",
    x1: 450.269,
    y1: 440.097,
    x2: 36.7284,
    y2: 201.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02000F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4532B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6347FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A3A5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_1233",
    x1: 77.2182,
    y1: 105.683,
    x2: 491.024,
    y2: 344.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02000F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4532B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6347FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A3A5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.95fe78190d5992552f196fefa83a2c1c.svg";
export { ForwardRef as ReactComponent };